import { BUTTON_STYLE_TYPE, COMPONENT_COLOR_THEMES, COMPONENT_VALUE_TYPES as types } from 'shared/constants';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

export interface Props {
  playlist?: {
    centerText?: boolean;
    title?: string;
    subtitle?: string;
    date?: string;
    countdownDate?: {
      date?: string;
      timezone?: string;
    };
    url?: string;
    linkUrl?: string;
    captionIcon?: string;
    captionHandle?: string;
    captionTitle?: string;
    captionSubtitle?: string;
    backgroundColor?: string;
    textColorTheme?: string;
    buttonType?: string;
    buttonText?: string;
  }[],
  extraSlide: {
    enabled?: boolean;
    textColorTheme?: string;
    text?: string;
    linkText?: string;
    linkUrl?: string;
    backgroundImageUrl?: string;
  }
}

const propsSchema: PropsSchemaList = [
  {
    key: 'playlist',
    label: 'Playlist',
    type: types.ARRAY,
    children: [
      {
        key: 'textColorTheme',
        label: 'Text Color Theme',
        type: types.ENUM,
        tooltip: 'Changes the text color',
        options: COMPONENT_COLOR_THEMES,
      },
      {
        key: 'centerText',
        label: 'Center the title, subtitle, date and button',
        type: types.BOOLEAN,
      },
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT,
      },
      {
        key: 'subtitle',
        label: 'Subtitle',
        type: types.TEXT,
      },
      {
        key: 'date',
        label: 'Date (No countdown)',
        type: types.TEXT,
      },
      {
        key: 'countdownDate',
        label: 'Countdown Date',
        tooltip: 'Timer till the event date',
        type: types.DATETIME,
      },
      {
        key: 'url',
        label: 'Video or Image URL',
        type: types.TEXT,
      },
      {
        key: 'linkUrl',
        label: 'Link URL',
        tooltip: 'Take the user to this link when the video is clicked',
        type: types.TEXT,
      },
      {
        key: 'captionIcon',
        label: 'Caption Icon',
        type: types.ICON_SOCIAL,
      },
      {
        key: 'captionHandle',
        label: 'Caption Handle',
        type: types.TEXT,
      },
      {
        key: 'captionTitle',
        label: 'Caption Title',
        type: types.TEXT,
      },
      {
        key: 'captionSubtitle',
        label: 'Caption Subtitle',
        type: types.TEXT,
      },
      {
        key: 'buttonType',
        label: 'Button Type',
        type: types.ENUM,
        options: BUTTON_STYLE_TYPE
      },
      {
        key: 'buttonText',
        label: 'Button Text',
        tooltip: 'Clicking on the button goes to the "Link URL"',
        type: types.TEXT,
      },
      {
        key: 'backgroundColor',
        label: 'Background Color',
        type: types.COLOR_PICKER,
      },
    ]
  },
  {
    key: 'extraSlide',
    label: 'Extra Slide',
    type: types.OBJECT,
    children: [
      {
        key: 'enabled',
        label: 'Enabled',
        type: types.BOOLEAN,
      },
      {
        key: 'textColorTheme',
        label: 'Text Color Theme',
        type: types.ENUM,
        tooltip: 'Changes the text color',
        options: COMPONENT_COLOR_THEMES,
      },
      {
        key: 'text',
        label: 'Text',
        type: types.TEXT,
      },
      {
        key: 'linkText',
        label: 'Link Text',
        type: types.TEXT,
      },
      {
        key: 'linkUrl',
        label: 'Link URL',
        type: types.TEXT,
      },
      {
        key: 'backgroundImageUrl',
        label: 'Background Image URL',
        type: types.S3_ASSET_URL,
      },
    ]
  }
];

const defaultProps: Props = {
  playlist: [
    {
      title: '1',
      url: 'https://demo.unified-streaming.com/k8s/features/stable/video/tears-of-steel/tears-of-steel.ism/.m3u8',
      captionIcon: 'ff-icon-logo',
      captionHandle: '@Faraday Future',
      captionTitle: 'FF Livestream',
      captionSubtitle: 'Welcome to Faraday Future',
    },
    {
      title: '2',
      url: 'http://media.w3.org/2010/05/sintel/trailer.mp4',
      captionIcon: 'ff-icon-logo',
      captionHandle: '@Faraday Future',
      captionTitle: 'New Announcement',
      captionSubtitle: 'Watch our new announcement video',
    },
    {
      title: '3',
      url: 'http://vjs.zencdn.net/v/oceans.mp4',
      captionIcon: 'ff-icon-logo',
      captionHandle: '@Faraday Future',
      captionTitle: 'Upcoming Events',
      captionSubtitle: 'See upcoming events at Faraday Future',
    },
  ],
  extraSlide: {
    enabled: true,
    text: '+60',
    linkText: 'View More',
    linkUrl: 'https://www.ff.com/us/91launch/',
    backgroundImageUrl: ''
  }
};

export default {
  title: 'Livestream Carousel',
  id: 'LivestreamCarousel',
  propsSchema,
  defaultProps,
}
